import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'
import {OilAnalysisActionDto} from '../../../types'

export const OilAnalysisActionQueryKey = 'oil-analysis-action'

const INTERVAL_PERIOD_IN_MS = 30_000

type Params = {
  plantUpmId?: string
  externalId: string
}

export const useOilAnalysisAction = (
  {plantUpmId, externalId}: Params,
  options?: UseQueryOptions<OilAnalysisActionDto, AxiosError>
) => {
  const path = `${TasksApiPath.OIL_ANALYSIS_ACTIONS}/${plantUpmId}/oil-analysis-actions/${externalId}`

  return useQuery<OilAnalysisActionDto, AxiosError>({
    queryKey: [OilAnalysisActionQueryKey, externalId, plantUpmId],
    queryFn: async ({signal}) => {
      const {data} = await ApiClient.axiosInstance.get<OilAnalysisActionDto>(path, {signal})

      return data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    enabled: !!plantUpmId,
    ...options
  })
}
